export default ["Events", "MenuService", "$rootScope", "matchmedia", "$window", function dcPageContainer( Events, MenuService, $rootScope, matchmedia, $window) {

  return {
    restrict: "A",
    scope: {},
    controller: ["$scope",function ($scope) {

      //console.log("page container");

      this.toggleSidebar = function () {

        $scope.sidebarCollapsed = !$scope.sidebarCollapsed;
        $scope.$emit(Events.NAV_TOGGLE_SIDEBAR, $scope.sidebarCollapsed);
        //console.log("toggle sidebar collapsed controller ", $scope.sidebarCollapsed);
      };

      this.toggleMainMenu = function () {
        $scope.mainMenuCollapsed = !$scope.mainMenuCollapsed;
        //console.log("main menu, ", $scope.mainMenuCollapsed);
        $rootScope.$emit(Events.NAV_TOGGLE_MENU, $scope.mainMenuCollapsed);
      };

      this.setMainMenuCollapsed = function (data) {
        //console.log("mainMenu collapsed: ", data);
        $scope.mainMenuCollapsed = data;
      };

      this.setSidebarCollapsed = function (data) {
        $scope.sidebarCollapsed = data;
      };

    }],
    link: function (scope, elem, attrs, ctrl) {

      var onReloadHeight = $rootScope.$on("dcPageContainer:reloadHeight", function () {
        if (document.createEvent) { // W3C
          var ev = document.createEvent('Event');
          ev.initEvent('resize', true, true);
          window.dispatchEvent(ev);
        }
        else { // IE
          element = document.documentElement;
          var event = document.createEventObject();
          element.fireEvent("onresize", event);
        }
      });

      var onToggleMenu = $rootScope.$on(Events.NAV_TOGGLE_MENU, function (e, data) {

        ctrl.setMainMenuCollapsed(data);

      });

      var onToggleSidebar = $rootScope.$on(Events.NAV_TOGGLE_SIDEBAR, function (e, data) {

        ctrl.setSidebarCollapsed(data);

        //console.log("page container collapsed menu");

        $(elem).removeClass('sidebar-collapsed');

        if (data) {
          $(elem).addClass('sidebar-collapsed');
        }

        //console.log("toggle sidebar collapsed link: ", scope.sidebarCollapsed);
      });

      scope.$on("$destroy", function () {
        onToggleSidebar();
        onReloadHeight();
        onToggleMenu();
      });
    }
  };

}];



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-navigation/dc-page-container.js